import React, { useState } from "react";
import { Card, Button } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';

export default () => {
  const [activeCategory, setActiveCategory] = useState("all");

  const categories = [
    { id: "all", name: "Tümü", count: 0 },
    { id: "dummy", name: "Dummy", count: 0 }
  ];

  return (
    <>
      <div className="py-4">
        <h4>Arşiv</h4>
      </div>

      <Card className="border-0 shadow-sm mb-4">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h5>Kategoriler</h5>
            <div className="d-flex gap-2">
              <Button variant="primary" size="sm">
                <FontAwesomeIcon icon={faPlus} className="me-2" />
                Yeni Kategori
              </Button>
              <Button variant="outline-secondary" size="sm">
                <FontAwesomeIcon icon={faEdit} className="me-2" />
                Düzenle
              </Button>
              <Button variant="outline-danger" size="sm">
                <FontAwesomeIcon icon={faTrash} className="me-2" />
                Sil
              </Button>
            </div>
          </div>

          <div className="d-flex gap-2 mb-4">
            {categories.map((category) => (
              <Button
                key={category.id}
                variant={activeCategory === category.id ? "primary" : "outline-secondary"}
                size="sm"
                onClick={() => setActiveCategory(category.id)}
              >
                {category.name}
              </Button>
            ))}
          </div>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <div></div>
            <div className="d-flex gap-2">
              <Button variant="primary" size="sm">
                <FontAwesomeIcon icon={faPlus} className="me-2" />
                Yeni Arşiv
              </Button>
              <Button variant="outline-danger" size="sm">
                <FontAwesomeIcon icon={faTrash} />
              </Button>
            </div>
          </div>

          <Card className="border-primary bg-light mb-3">
            <Card.Body className="py-3">
              <div className="d-flex align-items-center">
                <div className="bg-info rounded-circle d-flex align-items-center justify-content-center me-3" 
                     style={{ width: 40, height: 40, minWidth: 40 }}>
                  <span className="text-white fw-bold">i</span>
                </div>
                <div>
                  <h6 className="mb-1">Lütfen bir kategori seçin</h6>
                  <p className="mb-0 small text-muted">
                    Arşiv kayıtlarını görüntülemek için yukarıdan bir kategori seçiniz.
                  </p>
                </div>
              </div>
            </Card.Body>
          </Card>

          <Card className="border-warning bg-light mb-3">
            <Card.Body className="py-3">
              <div className="d-flex align-items-center">
                <div className="bg-warning rounded-circle d-flex align-items-center justify-content-center me-3" 
                     style={{ width: 40, height: 40, minWidth: 40 }}>
                  <span className="text-white fw-bold">!</span>
                </div>
                <div>
                  <h6 className="mb-1">Arşiv kaydı bulunamadı</h6>
                  <p className="mb-0 small text-muted">
                    Arşiv eklemek için "Yeni Arşiv" butonuna tıklayabilirsiniz.
                  </p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Card.Body>
      </Card>
    </>
  );
};
